import * as _ from 'lodash';
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IContactAdditionalInfo extends IModel {
	name?: string;
	value?: string;
	isExternalFormGenerated?: boolean;
}

const contactAdditionalInfoFactory = modelFactory.createFactory<IContactAdditionalInfo>('ContactAdditionalInfo', _.assign({}, model, {
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	isExternalFormGenerated: {
		setFilters: valueFilters.toBoolean
	}
}));

export default contactAdditionalInfoFactory;